
// Load app.css globally
import 'bootstrap/dist/css/bootstrap.min.css';
import "./src/components/styles/app.css"
